import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PERSISTENCY_MODULE_CONFIG } from '../persistency-module-config';

export type {
  LegacyApplicant,
  ApplicantAttachment,
} from '@sportello-balneari/api-client';
import type { LegacyApplicant, ApplicantAttachment } from '@sportello-balneari/api-client';

@Injectable({ providedIn: 'root' })
export class ApplicantPersistency {
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject(PERSISTENCY_MODULE_CONFIG);
  private readonly baseUrl = `${this.config.apiBaseUrl}/api/app/Applicants`;

  getApplicants(): Observable<LegacyApplicant[]> {
    return this.httpClient.get<LegacyApplicant[]>(this.baseUrl);
  }

  getApplicantById(id: string): Observable<LegacyApplicant> {
    return this.httpClient.get<LegacyApplicant>(`${this.baseUrl}/${id}`);
  }

  createApplicant(payload: {
    request: Partial<LegacyApplicant>;
  }): Observable<LegacyApplicant> {
    return this.httpClient.post<LegacyApplicant>(this.baseUrl, payload);
  }

  uploadApplicantAttachment(
    applicantId: string,
    file: File,
  ): Observable<ApplicantAttachment> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('applicantId', applicantId);

    return this.httpClient.post<ApplicantAttachment>(
      `${this.config.apiBaseUrl}/api/ApplicantAttachments`,
      formData,
    );
  }
}
